import { isDevelopment, isTesting } from '@honeybook/utils-web';
function reportToDataDog(name, context) {
    const datadog = window.DD_RUM;
    if (!datadog || !datadog.addAction) {
        if (isDevelopment() || isTesting()) {
            // eslint-disable-next-line no-restricted-syntax
            console.error('Could not report action to logger', name, context);
        }
        return;
    }
    datadog.addAction(name, context);
}
export function reportAction(props, enrichContext) {
    const { name, context = {} } = props;
    if (!name) {
        if (isDevelopment() || isTesting()) {
            // eslint-disable-next-line no-restricted-syntax
            console.error('name is required and was not provided');
        }
        return;
    }
    const enrichedContext = enrichContext ? enrichContext(context) : context;
    reportToDataDog(name, enrichedContext);
    if (isDevelopment() || isTesting()) {
        // eslint-disable-next-line no-restricted-syntax
        console.log('Report action to logger: ', name, enrichedContext);
    }
}
//# sourceMappingURL=action.utils.js.map